import { OpenInterestChangeRequest, OpenInterestChangeResponse, ParticipantData, ParticipantDataList, ParticipantOpenInterest_Type } from "../../proto/generated/open-interest"
import api from "./axiosClient"

export type FiiStats = {
    securityType: string,
    buyNumberOfContracts: number,
    buyAmountInCrores: number,
    sellNumberOfContracts: number,
    sellAmountInCrores: number,
    eodNumberOfContracts: number,
    eodAmountInCrores: number
}

export type ParticipantBuySellForCash = {
    type: ParticipantOpenInterest_Type,
    buyValueInCrores: number,
    sellValueInCrores: number,
    netValueInCrores: number
}

export type ParticipantNumberOfContracts = {
    type: ParticipantOpenInterest_Type,
    futureIndexLong: number,
    futureIndexShort: number,
    futureStockLong: number,
    futureStockShort: number,
    optionIndexCallLong: number,
    optionIndexPutLong: number,
    optionIndexCallShort: number,
    optionIndexPutShort: number,
    optionStockCallLong: number,
    optionStockPutLong: number,
    optionStockCallShort: number,
    optionStockPutShort: number,
    totalLongContracts: number,
    totalShortContracts: number
}

export type DailyParticipantData = {
    buySellForCash: ParticipantBuySellForCash[],
    fiiStats: FiiStats[],
    oiContracts:ParticipantNumberOfContracts[],
    volumeContracts: ParticipantNumberOfContracts[]
}

export type SentimentData = {
    strength: 'MILD' | 'MEDIUM' | 'STRONG' | 'STRENGTH_UNKNOWN',
    direction: 'BULLISH' | 'BEARISH' | 'INCONCLUSIVE',
    label: string
}

export type SegmentData = {
    label: string,
    netOi?: number,
    change: number,
    sentiment: SentimentData,
    children: SegmentData[]
}

export type ParticipantSummary = {
    type: 'FII' | 'DII' | 'PRO' | 'CLIENT',
    segments: SegmentData[]
}

export type DailySummary = {
    date: string,
    participants: ParticipantSummary[]
}

export type ParticipantSummaryRangeResponse = {
    summaries: DailySummary[]
}

export const getParticipantData = async (args: {params : any}): Promise<ParticipantData[]> => {
    return new Promise((resolve, reject) => {
        const url = `/participant-data`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            params: args.params,
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const participantList = ParticipantDataList.decode(new Uint8Array(response.data))
                resolve(participantList.list as ParticipantData[])
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const getOpenInterestChange = async (args: OpenInterestChangeRequest): Promise<OpenInterestChangeResponse> => {
    return new Promise((resolve, reject) => {
        const url = `/v2/options/oichange`
        api.post(url, JSON.stringify(args), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const responseData = OpenInterestChangeResponse.decode(new Uint8Array(response.data))
            resolve(responseData)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const getParticipantSummaryRange = async (args: {params: {startDate: string, endDate: string}}): Promise<ParticipantSummaryRangeResponse> => {
    return new Promise((resolve, reject) => {
        const url = `/participant-data/summary/range`
        api.get(url, {
            params: args.params
        })
            .then((response) => {
                resolve(response.data as ParticipantSummaryRangeResponse)
            })
            .catch((error) => {
                reject(error)
            })
    })
}